module.exports = __webpack_public_path__ + "img/assign.835c081f.svg";